import { useState } from "react";
import { EncabezadoPagina } from "../../components/EncabezadoPagina";
import { DashboardEjecutivoPage } from "./DashboardEjecutivoPage";
import { DashboardGeneralPage } from "./DashboardGeneralPage";
import { DashboardJudicialPage } from "./DashboardJudicialPage";

// 3 perspectivas (spec de la Vista General, tras auditoría UX): "General"
// es el termómetro que siempre abre primero; "Judicial"/"Financiero" son
// vistas de PROFUNDIZACIÓN a las que se llega por elección — mismo
// mecanismo de pestañas de siempre, sólo cambia cuál abre por defecto y el
// rol conceptual de cada una (ya no 3 pestañas de igual peso que hay que
// elegir antes de ver nada).
const PESTANAS = [
  { clave: "general", etiqueta: "General" },
  { clave: "judicial", etiqueta: "Judicial" },
  { clave: "financiero", etiqueta: "Financiero" },
] as const;

const DESCRIPCION_POR_PESTANA: Record<(typeof PESTANAS)[number]["clave"], string> = {
  general: "¿Cómo está el estudio? ¿Dónde debo intervenir? — termómetro de 30 segundos.",
  judicial: "Profundización 100% jurídica: expedientes, agenda y productividad procesal.",
  financiero: "Profundización financiera: finanzas, clientes, RRHH y objetivos.",
};

// Contenedor con pestañas para las 3 vistas del Dashboard (General /
// Judicial / Financiero) — no duplican información entre sí, cada una
// responde a un propósito distinto. Mismo patrón de pestañas que
// ExpedienteFichaPage (botones + estado local, sin componente Tabs
// genérico todavía).
export function DashboardPage() {
  const [pestana, setPestana] = useState<(typeof PESTANAS)[number]["clave"]>("general");

  return (
    <div>
      <EncabezadoPagina titulo="Paneles Ejecutivos" descripcion={DESCRIPCION_POR_PESTANA[pestana]} />

      <div className="mb-4 flex gap-2 border-b border-borde">
        {PESTANAS.map((p) => (
          <button
            key={p.clave}
            onClick={() => setPestana(p.clave)}
            className={`border-b-2 px-4 py-2.5 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secundario focus-visible:ring-offset-2 ${
              pestana === p.clave
                ? "border-principal text-principal"
                : "border-transparent text-texto-secundario hover:text-texto"
            }`}
          >
            {p.etiqueta}
          </button>
        ))}
      </div>

      {pestana === "general" && <DashboardGeneralPage />}
      {pestana === "judicial" && <DashboardJudicialPage />}
      {pestana === "financiero" && <DashboardEjecutivoPage />}
    </div>
  );
}
